<template>
  <a-select
    placeholder="数据来源"
    optionFilterProp="children"
    style="width: 100%"
    @change="handleChange"
    :filterOption="filterOption"
    ref="select"
    :defaultValue="theDefaultValue"
  >
    <a-select-option v-for="item in values" :key="item.key" ref="opts" :disabled="item.disabled || false">{{ item.value }}</a-select-option>
  </a-select>
</template>

<script>
import { getHospitalList } from '@/api/hospital'

export default {
  name: 'SelectHospital',
  data () {
    return {
      values: [],
      value: ''

    }
  },
  props: {
    theDefaultValue: {
      type: String
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var storedHospitals = this.$store.getters.projectHospitals
      if (storedHospitals.length != 0) this.values = storedHospitals
      else {
        const _this = this
        this.$store.dispatch('FetchProjectHospitals').then(hospitals => {
          _this.values = hospitals
        })
      }
    },
    handleChange (value) {
      this.value = value
      this.$emit('hospital_changed')
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
